'use strict';

var proRegularSvgIcons = {};

exports.__exports = proRegularSvgIcons;
//# sourceMappingURL=index7.cjs.map
